import React, { useContext } from "react";

import FancyBetRulesWrap from "../components/FancyBetRulesWrap";
import SportsBookRulesWrap from "../components/SportsBookRulesWrap";
import RulesofPremium from "../components/RulesofPremium";
import Backhome from "../components/Backhome";
import Please_login_to_proceed from "../components/Please_login_to_proceed";
import Openbets from "./Openbets";
import Setting from "./Setting";
import Anouncement from "./Anouncement";
import SearchWrap from "./SearchWrap";
import Loader from "./Loader";
import WelcomLoader from "./WelcomLoader";
import WalletWrap from "./WalletWrap";
import MessageBox from "./MessageBox";
import BookPosition from "./BookPosition";
import CasinoPopup from "./CasinoPopup";
import ComingSoonCasinoPopup from "./ComingSoonCasinoPopup";
import MarketDepth from "./MarketDepth";
import GameFooter from "./GameFooter";
import BetSlipParly from "../pages/MatchDetails/BetSlipParly";
import AuthContext from "../context/AuthContext";

function AllOverlay() {
  const { showParlyBet, parly } = useContext(AuthContext);
  return (
    <>
      {/* <WalletWrap/> */}
      {/* <MessageBox /> */}
      {/* <GameFooter/> */}
      <MarketDepth />
      <CasinoPopup />
      <ComingSoonCasinoPopup />
      <BookPosition />
      <SearchWrap />
      <Loader />
      <WelcomLoader />
      <FancyBetRulesWrap />
      <Anouncement />
      <SportsBookRulesWrap />
      <RulesofPremium />
      <Backhome />
      <Please_login_to_proceed />
      <Openbets />
      <Setting />
      {showParlyBet && parly && <BetSlipParly />}
    </>
  );
}

export default AllOverlay;
